(() => {
  if (customElements.get('flaay-size-chart')) return;
  customElements.define('flaay-size-chart', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-open]');
      if (!dialog || !trigger) return;
      trigger.addEventListener('click', () => {
        const template = dialog.querySelector('[data-chart-image]');
        if (template) template.replaceWith(template.content.cloneNode(true));
        if (!dialog.open) dialog.showModal();
      }, options);
      this.querySelector('[data-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => { if (trigger.isConnected) trigger.focus(); }, options);
    }
    disconnectedCallback() { this.abort?.abort(); this.querySelector('dialog')?.close(); }
  });
})();
